import React from 'react'
import {
  Collection,
  ForEachModel,
  useValue,
  WhenCollectionIsEmpty,
  WhenModelValue
} from '@morningtrain/react-resources'
import * as UI from 'ui'
import { Translation } from '@morningtrain/react-translations'
import ExchangeRequest from 'widgets/shifts/exchange/ExchangeRequest'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'
import { StaticFilter } from '@morningtrain/react-filters'
import ExchangeActions from 'widgets/shifts/exchange/ExchangeActions'
import { SelectedDepartmentFilter } from 'support/filters'
import { Can } from '@morningtrain/react-auth'

export default function ShiftExchangeDetails (props) {
  const slotId = useValue('id')
  const allMyExchangeRequests = useValue('all_my_exchange_requests')
  const availableExchangeActions = useValue('available_exchange_actions')
  const buyableExchangeId = useValue('buyable_exchange_id')

  const shiftIsMine = useValue('is_mine')
  const shiftUserId = useValue('user_id')
  const shiftCategory = useValue('category')

  if (!allMyExchangeRequests || allMyExchangeRequests.length === 0) {
    if (!availableExchangeActions || availableExchangeActions.length === 0) {
      return null
    }
  }

  return (
    <div className='space-y-4'>
      <UI.SecondaryHeading>
        <Translation name='shiftexchange.title' />
      </UI.SecondaryHeading>

      <Collection resourceName='shifts.exchange' operationName='requests'>
        <StaticFilter name='schedule_slot_id' value={slotId} />

        <WhenCollectionIsEmpty>
          <ExchangeActions slotId={slotId} />
        </WhenCollectionIsEmpty>

        <SmartviewTextGroup highlight>

          <ForEachModel>
            <SmartviewText>
              <ExchangeRequest
                slotId={slotId}
                shiftIsMine={shiftIsMine}
                shiftUserId={shiftUserId}
                shiftCategory={shiftCategory}
                initialExchangeId={buyableExchangeId}
              />
              <WhenModelValue name='exchange.id' condition={buyableExchangeId}>
                <ExchangeActions slotId={slotId} />
              </WhenModelValue>
            </SmartviewText>
          </ForEachModel>

        </SmartviewTextGroup>
      </Collection>

      <Can permission='api.shifts.exchange.manageable'>
        <Collection resourceName='shifts.exchange' operationName='manageable'>
          <StaticFilter name='shift_id' value={slotId} />
          <SmartviewTextGroup highlight>

            <ForEachModel>
              <SmartviewText>
                <ExchangeRequest
                  slotId={slotId}
                  shiftIsMine={shiftIsMine}
                  shiftUserId={shiftUserId}
                  shiftCategory={shiftCategory}
                  initialExchangeId={buyableExchangeId}
                />
                <WhenModelValue name='exchange.id' condition={buyableExchangeId}>
                  <ExchangeActions slotId={slotId} />
                </WhenModelValue>
              </SmartviewText>
            </ForEachModel>

          </SmartviewTextGroup>
        </Collection>
      </Can>

    </div>
  )
}
